import { render, staticRenderFns } from "./ModalDeleteMessage.vue?vue&type=template&id=0581b87a&"
import script from "./ModalDeleteMessage.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports